import React, { useState } from "react";
import SEO from "../components/SEO";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./css/Career.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
const Careers = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <SEO
        title="Careers - Joujo Safaris"
        description="Join the Joujo Safaris team and be part of a travel company dedicated to unforgettable safaris, cultural experiences, and global adventures."
        url="https://joujosafaris.com/careers"
        image="https://www.joujosafaris.com/static/media/logo.87843514b1c67d56f320.png"
        keywords="careers, jobs, work with us, join joujo safaris, safari jobs, travel jobs in kenya"
      />
      <Navbar />

      <section className="container career-hero">
        <div className="career-text">
          <div className="career-sub-title">
            <h4 className="text-color">Join Us</h4>
            <h5>Become a Part <br />Of Our Team</h5>
          </div>
          <p>
            JOUJO SAFARIS, a subsidiary of JOIN US JOINERS, is dedicated to wildlife
            and community welfare through sustainable tourism. By joining our team,
            you become part of a movement that creates impact while delivering
            world-class safari experiences.
          </p>
          <button
            className="btn-medium"
            onClick={() => setShowModal(true)}
          >
            Apply Now <i className="fas fa-arrow-right"></i>
          </button>
        </div>
        <div className="career-parallax"></div>
      </section>

      {/* Hiring Process Section */}
      <section className="career-process container">
        <div className="career-main-title">
          <h4 className="text-color">Our Process</h4>
          <h5>Hiring Process</h5>
        </div>
        <div className="career-process-grid">
          <div className="cpg">
            <h2>01</h2>
            <h3>Send Application</h3>
            <p>Submit your resume and cover letter through our careers portal.</p>
          </div>
          <div className="cpg">
            <h2>02</h2>
            <h3>Application Review</h3>
            <p>Our HR team carefully reviews your qualifications and experience.</p>
          </div>
          <div className="cpg">
            <h2>03</h2>
            <h3>Scheduled Interview</h3>
            <p>Shortlisted candidates will be invited for an interview with our team.</p>
          </div>
        </div>
      </section>

      {/* Modal for Apply Now */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Careers Coming Soon</h3>
            <p>
              Our Careers page is not available yet. Please check back soon or
              send your resume to <a href="mailto:info@joujosafaris.com">careers@joujosafaris.com</a>.
            </p>
            <button className="btn-medium" onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}

      <section className="cpar sm-hid container">
        <div className="sm-hid"></div>
        <div className="sm-hid">
          <LazyLoadImage effect="blur" src={require("../assets/image/9.jpg")} alt="" />
        </div>
        <div>
          <LazyLoadImage effect="blur" src={require("../assets/image/56.jpg")} alt="" />
        </div>
      </section>

      <section className="about-team container" id="team">
        <div className="about-main-title">
          <h4 className="text-color">Our Team</h4>
          <h5>Our Team</h5>
        </div>
        <div className="about-team-card">
          <div className="about-team-grid">
            <div className="about-team-img">
              <LazyLoadImage effect="blur" src={require("../assets/image/hildah_maina_ceo_founder_joujo.jpg")} alt="Hildah Maina" />
              <h3>Hildah Maina</h3>
              <h4>CEO / FOUNDER</h4>
              <p>"In the jungle, the mighty jungle"</p>
            </div>
          </div>
          <div className="about-team-grid">
            <div className="about-team-img">
              <LazyLoadImage effect="blur" src={require("../assets/image/njuguna_kieti_CTO.jpg")} alt="Kieti Njuguna" />
              <h3>Kieti Njuguna</h3>
              <h4>Chief Technology Officer</h4>
              <span
                style={{
                  backgroundColor: "#000",
                  color: "#fff",
                  fontFamily: "monospace",
                  borderRadius: "4px",
                }}
              >
                &lt;p&gt;Hello World&lt;/p&gt;
              </span>
            </div>
          </div>
          <div className="about-team-grid">
            <div className="about-team-img">
              <LazyLoadImage effect="blur" src={require("../assets/image/zipporah_tours_brand_ambassador.jpg")} alt="Zipporah Wachira" />
              <h3>Zipporah Wachira</h3>
              <h4>Brand Ambassador</h4>
              <p>"Cruising Down Memory Lane"</p>
            </div>
          </div>
          <div className="about-team-grid">
            <div className="about-team-img">
              <LazyLoadImage effect="blur" src={require("../assets/image/fidelis_maina_joujo_team.jpeg")} alt="Fidelis Maina" />
              <h3>Fidelis Maina</h3>
              <h4>Tour Operator</h4>
              <p>"You deserve better, but someone had to step up"</p>
            </div>
          </div>
          <div className="about-team-grid">
            <div className="about-team-img">
              <LazyLoadImage effect="blur"
                src={require("../assets/image/eric_thiong'o_driver_joujo_safaris.jpg")}
                alt="Eric Thiong'o"
              />
              <h3>Eric Thiong'o</h3>
              <h4>Driver</h4>
              
                <p>
                "Cruisin down Memory lane"
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Careers;
